// file-saver is a heavyweight dep; load it only when the user triggers a
// download. Keep the dynamic import private so callers see a normal async fn.
async function loadSaveAs() {
  const mod = await import("file-saver");
  return mod.saveAs;
}

export async function downloadBlob(blob: Blob, filename: string): Promise<void> {
  const saveAs = await loadSaveAs();
  saveAs(blob, filename);
}
